import React, { useMemo } from 'react';
// eslint-disable-next-line no-restricted-imports -- Retains the control cohort during the banner store migration.
import { Subscribe } from 'unstated';

import { expValEquals } from '@confluence/feature-experiments';
import {
	useBannerActions,
	useBannerEntries,
} from '@confluence/banners/entry-points/useBannerState.ts';

import { LoadableAfterPaint } from '@confluence/loadable';
import { BannerStateContainer } from '@confluence/banners/entry-points/BannerStateContainer.ts';

import { useIsPageEligibleForAdminAnnouncementBanner } from './useIsPageEligibleForAdminAnnouncementBanner.ts';

const AdminAnnouncementBannerInner = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AdminAnnouncementBannerInner" */ './AdminAnnouncementBannerInner.tsx'
			)
		).AdminAnnouncementBannerInner,
});

const AdminAnnouncementBannerWithHooks = () => {
	const banners = useBannerEntries();
	const actions = useBannerActions();
	const bannerState = useMemo(() => ({ ...actions, state: { banners } }), [actions, banners]);
	return <AdminAnnouncementBannerInner bannerState={bannerState} />;
};

export const AdminAnnouncementBanner = (): React.JSX.Element | null => {
	const isPageEligibleForAdminAnnouncementBanner = useIsPageEligibleForAdminAnnouncementBanner();
	if (!isPageEligibleForAdminAnnouncementBanner) {
		return null;
	}
	if (expValEquals('confluence_banner_store_migration', 'isEnabled', true)) {
		return <AdminAnnouncementBannerWithHooks />;
	}
	return (
		<Subscribe to={[BannerStateContainer]}>
			{(bannerState: BannerStateContainer) => {
				return <AdminAnnouncementBannerInner bannerState={bannerState} />;
			}}
		</Subscribe>
	);
};
